import React, { useId, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon, PlusIcon } from "lucide-react";
type DisclosureProps = {
  title: string;
  children: React.ReactNode;
  variant?: "plus" | "chevron";
};
export function Disclosure({
  title,
  children,
  variant = "plus"
}: DisclosureProps) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return <div className="border-b border-line" data-id="element-176" data-mp="zab35rmgq3rh">
      <h3 data-id="element-177" data-mp="z8zxtnddcny9">
        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls={id} className={`flex w-full items-center gap-4 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose ${variant === "chevron" ? "justify-between" : ""}`} data-id="element-178" data-mp="z8q4bpt47ynt">
          {variant === "plus" && <PlusIcon className={`h-5 w-5 shrink-0 text-wine transition-transform duration-200 ease-out ${open ? "rotate-45" : ""}`} strokeWidth={1.5} aria-hidden="true" data-id="element-179" data-mp="blhzf8zlmrmb" />}
          <span className={variant === "plus" ? "text-base font-semibold text-wine sm:text-[17px]" : "font-serif text-[17px] font-semibold leading-snug text-wine sm:text-lg"} data-id="element-180" data-mp="39at9u3fbpfli">
            {title}
          </span>
          {variant === "chevron" && <ChevronDownIcon className={`h-5 w-5 shrink-0 text-rose transition-transform duration-200 ease-out ${open ? "rotate-180" : ""}`} strokeWidth={1.75} aria-hidden="true" data-id="element-181" data-mp="2lfyxvncn6hg8" />}
        </button>
      </h3>
      <AnimatePresence initial={false} data-id="element-182" data-mp="2zegihc793dtx">
        {open && <motion.div id={id} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden" data-id="element-183" data-mp="9olhfyj1qxqj">
            <p className={`pb-5 text-[15px] leading-relaxed text-ink sm:text-base ${variant === "plus" ? "pl-9" : "pr-8"}`} data-id="element-184" data-mp="26pis1y6aooi6">
              {children}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}